const lockdown = {
  lockdown: 'Aislamiento',
  lockdown_options: 'Opciones de bloqueo',
  start_lockdown_message:
    'Para iniciar el bloqueo del sitio - {{site}}, escriba su contraseña y luego presione confirmar.',
  stop_lockdown_message:
    'Para detener el bloqueo del sitio - {{site}}, escriba su contraseña y luego presione confirmar.',
  settings_modal_tile: 'Bloqueo - {{site}}',
  start_options: 'Opciones de inicio',
  stop_options: 'Detener opciones',
  login_required: 'Se requiere contraseña de inicio de sesión',
  card_pin_options: 'Opciones de credenciales y PIN',
  confirm_start_lockdown:
    '¿Está seguro de que quieres iniciar el bloqueo del sitio {{site}}?',
  confirm_stop_lockdown:
    '¿Está seguro de que quieres detener el bloqueo del sitio {{site}}?',
  pin_option: {
    single_swipe: 'un solo golpe',
    double_swipe: 'Se requiere doble deslizamiento',
    two_men: 'Acceso para 2 usuarios (acompañante) requerido',
  },
  cannot_edit:
    'Se está llevando a cabo un bloqueo. No es posible editar la configuración en este momento.',
};

export default lockdown;
